import { styled } from '@mui/material/styles'
import ButtonBase from '@mui/material/ButtonBase'

const PREFIX = 'ContactUsButton'

export const classes = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
  contactUsBtn: `${PREFIX}-contactUsBtn`,
  btn: `${PREFIX}-btn`,
  contactUsBtnText: `${PREFIX}-contactUsBtnText`,
}

const StyledButtonBase = styled(ButtonBase)(({ theme }) => ({
  [`& .${classes.root}`]: {
    color: theme.palette.primary.main,
    height: '36px',
    width: '36px',
  },

  [`& .${classes.icon}`]: {
    fontSize: 36,
  },

  [`&.${classes.contactUsBtn}`]: {
    paddingTop: 0,
  },

  [`&.${classes.btn}`]: {
    maxHeight: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    minWidth: 'fit-content',
    paddingRight: 8,
    paddingLeft: 8,
  },

  [`& .${classes.contactUsBtnText}`]: {
    fontSize: 10,
  },
}))

export default StyledButtonBase
